module.exports = __webpack_public_path__ + "assets/img/img_new.0f270a00.svg";